
import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, Building, Users, Calendar } from "lucide-react";
import { useIntersectionObserver } from "@/hooks/use-intersection-observer";

const OpportunitiesSection = () => {
  const { elementRef: titleRef, isVisible: titleVisible } = useIntersectionObserver();
  const { elementRef: cardsRef, isVisible: cardsVisible } = useIntersectionObserver();
  const { elementRef: footerRef, isVisible: footerVisible } = useIntersectionObserver();

  const opportunities = [
    {
      icon: TrendingUp,
      title: "Indépendant rentable",
      description: "Rester indépendant et générer un bon niveau de revenus"
    },
    {
      icon: Building,
      title: "Devenir franchisé", 
      description: "Monter en puissance et devenir franchisé"
    },
    {
      icon: Users,
      title: "Constituer une équipe",
      description: "Ouvrir une agence et constituer une équipe"
    },
    {
      icon: Calendar,
      title: "Événements du réseau",
      description: "Participer à des événements internes, formations continues, rencontres régionales"
    }
  ];

  return (
    <section className="py-20 gradient-bg text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div 
          ref={titleRef}
          className={`text-center mb-16 transition-all duration-800 ${
            titleVisible ? 'animate-slide-in-up' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            🌱 Quelles sont les <span className="text-white">opportunités</span> ?
          </h2>
        </div>

        <div 
          ref={cardsRef}
          className="grid md:grid-cols-2 gap-8 mb-12 max-w-6xl mx-auto"
        >
          {opportunities.map((opportunity, index) => (
            <Card 
              key={index} 
              className={`group bg-white/10 backdrop-blur-sm border-white/20 hover:bg-white/20 transition-all duration-500 hover:-translate-y-2 ${
                cardsVisible 
                  ? `animate-slide-in-up animate-stagger-${(index % 4) + 1}` 
                  : 'opacity-0 translate-y-10'
              }`}
            >
              <CardContent className="p-8">
                <div className="flex items-start space-x-6">
                  <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors duration-300">
                    <opportunity.icon className="w-8 h-8 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold mb-3 text-white">{opportunity.title}</h3>
                    <p className="text-white/80 leading-relaxed">{opportunity.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <div 
            ref={footerRef}
            className={`bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20 max-w-2xl mx-auto transition-all duration-800 ${
              footerVisible ? 'animate-scale-in' : 'opacity-0 scale-95'
            }`}
          >
            <h3 className="text-2xl font-bold mb-4 text-white">Votre évolution dépend de vos envies</h3>
            <p className="text-white/90 text-lg leading-relaxed">
              Chez Work&You, nous nous adaptons à vos ambitions et vous accompagnons dans toutes vos évolutions professionnelles.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OpportunitiesSection;
